import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2" data-testid="forgot-page">
      <div className="bg-[var(--peak-ink)] text-white p-10 md:p-16 flex flex-col justify-between">
        <div className="font-heading font-black text-2xl tracking-tighter">PEAK CRM</div>
        <div>
          <h1 className="font-heading font-black uppercase text-4xl md:text-6xl leading-[0.9] tracking-tighter">
            Locked out?<br/>Reset in 60 seconds.
          </h1>
          <p className="mt-6 text-lg font-medium max-w-md">
            We'll send a secure reset link to your email. Meanwhile the link is also written to the server log for local development.
          </p>
        </div>
        <div className="section-label text-white/60">© 2026 Peak Labs.</div>
      </div>
      <div className="bg-white p-10 md:p-16 flex items-center">
        {sent ? (
          <div className="w-full max-w-md" data-testid="forgot-sent">
            <div className="section-label text-[#008A27]">Reset link sent</div>
            <h2 className="font-heading font-black text-3xl md:text-4xl tracking-tighter mt-1">Check your email.</h2>
            <p className="mt-3 text-sm text-[var(--peak-muted)]">If an account exists, a reset link has been generated. Since email is currently mocked, the link is also logged to the backend server log.</p>
            <Link to="/login" className="mt-6 inline-block font-bold underline hover:text-[var(--peak-accent)]">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="forgot-form">
            <div>
              <div className="section-label">Forgot password</div>
              <h2 className="font-heading font-black text-3xl md:text-4xl tracking-tighter mt-1">Reset your access.</h2>
            </div>
            <div>
              <label className="section-label">Email</label>
              <input required type="email" data-testid="forgot-email" className="brutalist-input" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full bg-[var(--peak-accent)] hover:bg-black text-white font-bold uppercase tracking-widest px-6 py-4 disabled:opacity-60">
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-sm"><Link to="/login" className="font-bold underline hover:text-[var(--peak-accent)]">Back to sign in</Link></div>
          </form>
        )}
      </div>
    </div>
  );
}
